<template>
  <div id="LmFormBuilder" class="wrapper-content w-100">
    <h1 v-if="pageTitleData">{{pageTitleData}}</h1>
    <LmForm ref="lmFormRef">
      <portal-target name="destination-after-title" slim/>
      <template v-for="(formRow, index) in formElements">
        <component
          v-if="formRow.componentName !== 'LmButton'"
          :ref="`componentRef${index}`"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          :v="$v.formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :showEditButton="isOnPreviewMode"
          v-bind="formRow.componentProps"
          v-model="formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          @edit-button-clicked="click(formRow, index)"
          @onUpdate="formObjectToSendToServer[formRow.formObjectToSendToServerProperty] = $event"
        />
        <portal-target v-if="shouldCreatePortal(formRow.componentName)" :key="`destination-key-${index}`" :name="`destination-${index}`" slim/>
        <component
          v-if="formRow.componentName === 'LmButton'"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          v-bind="formRow.componentProps"
          @click.native="click(formRow)"
        />
      </template>
      <portal-target name="button-submit" slim/>
    </LmForm>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'

import commonsApi from '@/api/commons'

import LmForm from '@/components/form/LmForm'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmDate from '@/components/form/elements/LmDate'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'
import LmFormEmptySpace from '@/components/form/elements/LmFormEmptySpace'
import LmFormSeparator from '@/components/form/elements/LmFormSeparator'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmEditor from '@/components/LmEditor.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmHtmlContent from '@/components/form/elements/LmHtmlContent'
import LmPortalTarget from '@/components/form/elements/LmPortalTarget'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmComment from '@/components/LmComment'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmPassword,
    LmEmailInput,
    LmNumberInput,
    LmTextArea,
    LmSelect,
    LmFormSubtitles,
    LmFormEmptySpace,
    LmFormSeparator,
    LmDate,
    LmDateTime,
    LmSuperPowerSelectV2,
    LmEditor,
    LmLeaFletMap,
    LmHtmlContent,
    LmPortalTarget,
    LmColorPicker,
    LmComment
  },
  data () {
    return {
      registerOfDataWatchDinamically: {},
      pageTitleData: '',
      messageAfterPOSTorPUT: 'Guardado',
      pathToRedirectAfterPOSTorPUT: '/',
      apiRestForHandleAllHttpMethods: '',
      formObjectToSendToServer: {},
      formElements: [],
      validationsData: {},
      conditionals: []
    }
  },
  validations () {
    const validationsRules = {
      formObjectToSendToServer: {}
    }
    for (const property in this.validationsData) {
      validationsRules.formObjectToSendToServer[property] = {}
      for (const innerObjectProperty in this.validationsData[property]) {
        switch (innerObjectProperty) {
          case 'required':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = required
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'email':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = email
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'minLength':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = minLength(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'maxLength':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = maxLength(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'numeric':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = numeric
            break
          case 'sameAs':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = sameAs(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break

          default:
            break
        }
      }
    }
    return validationsRules
  },
  props: {
    isOnPreviewMode: {
      type: Boolean,
      default: false
    },
    getComponents: {
      type: Object,
      default: () => ({})
    },
    endpointUriwhereGetComponents: {
      type: String,
      default: ''
    },
    endpointUriWhereGetValuesToLoadInEditMode: {
      type: String,
      default: ''
    }
  },
  methods: {
    showAllFormElements () {
      this.formElements.forEach((_, formElementIndex) => {
        this.formElements[formElementIndex].componentProps.isVisible = true
      })
    },
    hideFormelements (formElements) {
      formElements.forEach(formElement => {
        const formElementIndex = this.formElements.findIndex(e => e.id === formElement.id)
        this.formElements[formElementIndex].componentProps.isVisible = false
      })
    },
    showFormelements (formElements) {
      formElements.forEach(formElement => {
        const formElementIndex = this.formElements.findIndex(e => e.id === formElement.id)
        this.formElements[formElementIndex].componentProps.isVisible = true
      })
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    async initializeComponent () {
      if (Object.keys(this.getComponents).length) {
        this.formElements = this.getComponents.formElements
        this.validationsData = this.getComponents.validations
        this.conditionals = this.getComponents.conditionals
      } else {
        const endPoint = await commonsApi.axiosGetWrapper(this.endpointUriwhereGetComponents)
        this.pageTitleData = endPoint.data.pageTitleData
        this.messageAfterPOSTorPUT = endPoint.data.messageAfterPOSTorPUT
        this.pathToRedirectAfterPOSTorPUT = endPoint.data.pathToRedirectAfterPOSTorPUT
        this.apiRestForHandleAllHttpMethods = endPoint.data.apiRestForHandleAllHttpMethods
        this.formElements = endPoint.data.formElements
        this.validationsData = endPoint.data.validations
        this.conditionals = endPoint.data.conditionals
      }
    },
    getValueFromFormElements (value) {
      return value?.name || value
    },
    setWatcherForConditionalsFields () {
      this.conditionals.forEach((conditional) => {
        this.$watch(() => this.formObjectToSendToServer[conditional.leftValueToCompare], async function () {
          const leftValueToCompare = this.getValueFromFormElements(this.formObjectToSendToServer[conditional.leftValueToCompare])
          const rightValueToCompare = conditional.rightValueToCompare
          const comparation = conditional.comparation
          switch (comparation) {
            case '===':
              if (leftValueToCompare === rightValueToCompare) {
                console.log('=== match: hide this ones []')
                this.hideFormelements(conditional.actions.formElementsToHide)
                this.showFormelements(conditional.actions.formElementsToShow)
              }
              break
            case '!==':
              if (leftValueToCompare !== rightValueToCompare) {
                console.log('!== match: hide this ones []')
              }
              break
            case '>':
              if (leftValueToCompare > rightValueToCompare) {
                console.log('hide this ones []')
              }
              break
          }
        })
      })
    },
    setWatcher (component, index) {
      const isWatcherInRegister = component.formObjectToSendToServerProperty in this.registerOfDataWatchDinamically
      const componentHasChild = component.childrenOf
      const watchMustBeCreated = component.componentName === 'LmSuperPowerSelectV2' && componentHasChild && !isWatcherInRegister
      const watchMustBeRemoved = isWatcherInRegister && !componentHasChild

      const createWatch = () => {
        const unWatch = this.$watch(`formObjectToSendToServer.${component['childrenOf']}`, async function () {
          if (this.formObjectToSendToServer[component.childrenOf]?.id) {
            this.formElements[index].componentProps.options = await this.$refs[`componentRef${index}`][0].getOptionsFromPath(`${this.formElements[index].componentProps.urlPathFromGetOptions}/${this.formObjectToSendToServer[component.childrenOf].id}`)
            this.formElements[index].componentProps.disabled = false
          } else {
            this.formElements[index].componentProps.disabled = true
          }
        })
        return unWatch
      }

      const registerWatch = (unWatch) => {
        this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty] = {
          unWatch
        }
      }

      const setOptionsSuperPowerWhenHasNotChildren = async () => {
        const options = await this.$refs[`componentRef${index}`][0].getOptionsFromPath(this.formElements[index].componentProps.urlPathFromGetOptions)
        this.formElements[index].componentProps.options = options
        this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty].unWatch()
        delete this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty]
      }
      if (watchMustBeCreated) {
        const unWatch = createWatch()
        registerWatch(unWatch)
      } else if (watchMustBeRemoved) {
        setOptionsSuperPowerWhenHasNotChildren()
      }
    },
    async setForm () {
      if (this.endpointUriWhereGetValuesToLoadInEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: this.endpointUriWhereGetValuesToLoadInEditMode,
          id: '',
          paramsMode: true }, 'formObjectToSendToServer')
        this.$emit('formLoadingComplete')
      }
    },
    async click (formRow, index) {
      if (this.isOnPreviewMode) {
        this.$emit('openEditFormElement', index)
      }
      if (formRow?.actions) {
        switch (formRow?.actions?.click?.type) {
          case 'submit':
            await this.$refs.lmFormRef.validationForm(this.$v)
            if (this.endpointUriWhereGetValuesToLoadInEditMode) {
              this.$refs.lmFormRef.showLoading()
              const pathUpdate = formRow?.actions?.click?.arguments?.pathUpdate || this.apiRestForHandleAllHttpMethods
              await commonsApi.axiosPutWrapper(pathUpdate + this.$route.params.id, this.formObjectToSendToServer)
              this.lmToastSuccessMessage(this.messageAfterPOSTorPUT, 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            } else {
              this.$refs.lmFormRef.showLoading()
              await commonsApi.axiosPostWrapper(formRow?.actions?.click?.arguments?.path || this.apiRestForHandleAllHttpMethods, this.formObjectToSendToServer)
              this.lmToastSuccessMessage(this.messageAfterPOSTorPUT, 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            }
            break
          case 'cancel':
            this.$router.go(-1)
            break
          default:
            break
        }
      }
    },
    setFormElements () {
      this.formElements.forEach((component, index) => {
        if (component.formObjectToSendToServerProperty) {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, '')
        }
        if (component.componentName === 'lmSuperPowerSelectV2') {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, { id: '', name: '' })
        }
        if (component.componentName === 'lmSuperPowerSelectV2Multiple' && component?.componentProps.multiple) {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, [])
        }
        if (
          (component.componentName === 'LmDate' || component.componentName === 'LmDateTime') &&
        this.formElements[index].componentProps &&
        this.formElements[index].componentProps.config
        ) {
          this.formElements[index].componentProps.config.locale = Spanish
        }
        this.setWatcher(component, index)
      })
    }
  },
  watch: {
    endpointUriWhereGetValuesToLoadInEditMode () {
      this.setForm()
    },
    endpointUriwhereGetComponents () {
      this.initializeComponent()
    },
    'getComponents.pageTitleData' () {
      this.pageTitleData = this.getComponents.pageTitleData
    },
    'getComponents.apiRestForHandleAllHttpMethods' () {
      this.apiRestForHandleAllHttpMethods = this.getComponents.apiRestForHandleAllHttpMethods
    },
    'getComponents.validations' () {
      this.validationsData = this.getComponents.validations
    },
    'getComponents.conditionals' () {
      this.conditionals = this.getComponents.conditionals
      this.setWatcherForConditionalsFields()
    },
    'getComponents.formElements': {
      handler: function () {
        this.formElements = this.getComponents.formElements
        this.setFormElements()
      },
      deep: true
    },
    formObjectToSendToServer: {
      handler: function () {
        this.$emit('formObjectToSendToServerChange', this.formObjectToSendToServer)
      },
      deep: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.setForm()
    }, 500)
  },
  async created () {
    await this.initializeComponent()
    this.setFormElements()
    this.setWatcherForConditionalsFields()
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  .form-wrapper
    margin-right: -15px
    margin-left: -15px
  #form
    display: -ms-flexbox
    display: -webkit-box
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    width: 100%
</style>
